import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'rch-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {

}
